<template>
  <div>
    <CRow>
      <CCol  sm="4">
        <CCard color="warning">
          <CCardBody class="p-3 mx-5 mb-2  text-white">
            <CCallout color="danger">
                <h1><strong>App Users</strong></h1><br>
             
        <strong class="h4">{{dashboard.noOfUsers}}</strong>
      </CCallout>
          </CCardBody>
        </CCard>
      </CCol>
       <CCol  sm="4">
        <CCard color="info">
          <CCardBody class="p-3 mx-5 mb-2  text-white">
            <CCallout color="danger">
                <h1><strong>Classes</strong></h1><br>
        <strong class="h4">{{dashboard.noOfClasses}}</strong>
      </CCallout>
          </CCardBody>
        </CCard>
      </CCol>
       <CCol  sm="4">
        <CCard color="dark">
          <CCardBody class="p-3 mx-5 mb-2  text-white">
            <CCallout color="danger">
                <h1>Courses</h1><br>
        <strong class="h4">{{dashboard.noOfCourses}}</strong>
      </CCallout>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "Dashboard",
  
  data() {
    return {
      dashboard: {
        
      },
    };
  },
  created() {
   
  },
  methods: {
    getDashboard() {
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST +
          "/web/secure/dashboard" 
      )
        .then((response) => response.json())
        .then((data) => (this.dashboard = data));
    },
  },
  mounted() {
    this.getDashboard();
  },
};
</script>